module.exports = __webpack_public_path__ + "img/undset_Kristin_Lavransdatter1.fd153eb1.jpg";